import api from '@/modules/api'
import url from '@/modules/url'
import sessionStorage from '@/components/cache'
import getIP from '@/components/utils/getIP'
import { setBirthFromIdNo } from "@/components/utils/dateUtil";
import { Loading } from "element-ui";
import { ERR } from './errCode'

import ValidateUtility from './validator'
export default {
  data() {
    
    return {
      uploadData: {
        domain: 'POLICY',
        buz: 'POLICY_PICTURE',
        expired: 60,
        actions: '',
        buzId: '123',
        auth: 1
      },
      recruitUploadData: {
        domain: 'recruit',
        buz: 'recruit_pdf',
        expired: -1,
        actions: '',
        buzId: '123',
        auth: 0
      },
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      recruitUploadHeader: {
        'ComId': 'hasl-isp',
        'Authorization': 'Basic ' + sessionStorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.session_get('username')
      },
      basicInfo: {
        sex: '',
        birthday: '',
        nationality: '01', // 民族
        marriage: '01', // 婚姻状态
        nativePlace: [], // 籍贯
        originProvince: '',
        originCity: '',
        originArea: '',
        permanentResidence: [], //户口所在地
        residenceProvince: '',
        residenceCity: '',
        residenceArea: '',
        liveGrounds: [], //现居住地
        liveProvince: '',
        liveCity: '',
        liveArea: '',
        liveAddress: '', //现居住地-详细地址
        familyAdress: [],// 家庭住址
        familyProvince: '',
        familyCity: '',
        familyArea: '',
        address: '', // 家庭住址-详细地址
        email: '', // 电子邮件
        expMonIncome: '', // 月收入愿望
        monIncome: '', // 现在月均收入
        emergencyConName: '', // 紧急联络人
        emergencyConTel: '',// 紧急联络人电话
        earliestWorkHour: '', // 预计最早上班时间
      }, //基本信息
      errorsWork: [], // 工作经历
      errorsEducation: [], // 学习经历
      errorsFamily: [], // 家庭成员
      accountOther: {
        ques1: '0',
        ques2: '0',
        ques3: '0',
        ques4: '0',
        ques5: '0',
        ques6: '0',
        ques7: '0',
      }, //其他信息
      uploadImgs:{
        IdPhotoFront: '',
        IdPhotoBack: '',
        certificateFrontPhotoFileId: [{ url: "https://via.placeholder.com/150" }], // 证件照片-正面
        certificateBackPhotoFileId: [{ url: "https://via.placeholder.com/150" }], // 证件照片-反面
        educationPhotoFileId: [{ url: "https://via.placeholder.com/150" }], // 学历照片
        degreePhotoFileId: [{ url: "https://via.placeholder.com/150" }], // 学位证书
        interviewPhotoFileId: [{ url: "https://via.placeholder.com/150" }] // 面试影像
      }, //上传图片信息
      workJson:{
        unit: '',
        dept:'',
        job:'',
        transReason:'',
        beginDate: '',
        endDate: '',
        reterence:'',
        tel:'',
        dateRange: [],
        isEditing: true,
        beginDate: '',
        endDate: ''
      },
      educationJson: {
        school: '',
        specialty: '',
        degree: '',
        beginDate: '',
        endDate: '',
        specialtyBackground: '',
        dateRange: [],
        isEditing: true,
        beginDate: '',
        endDate: ''
      },
      familieJson: {
        name: '',
        relationship: '',
        relativesBirthday: '',
        unit: '',
        profession: '',
        relativesIdType: '',
        relativesIdNo: '',
        isEditing: true
      }
    }
  },
  mounted() {
  },
  methods: {
    getImgUrl(file){},
    // 家庭成员-双击编辑
    handleFamilyRowDblClick(row){
      this.$set(row, "isEditing", true);
    },
    // 家庭成员-结束编辑，保存数据
    saveFamilyEdit(row, field, idx) {
      let { families } = this.accountResumeData
      if ("relativesIdNo" === field) {
        let msg = this.checkCard(row["relativesIdType"], row["relativesIdNo"])
        if (msg) {
          this.$message.error(msg)
          return;
        }
        let birthObj = setBirthFromIdNo(row["relativesIdType"], row["relativesIdNo"]);
        if (birthObj && birthObj.birthDate) {
          this.$set(families[idx], "relativesBirthday", birthObj.birthDate);
        }
        if (birthObj && birthObj.sex) {
          this.$set(families[idx], "relativesSex", birthObj.sex);
        }
      }
      
      if (idx > -1) {
        this.$set(families[idx], field, row[field]);
      }
      // if(field == 'relativesIdNo') {
      //   this.validateID(row)
      // }
      row.isEditing = false; // 退出编辑模式
    },
    //  家庭成员- 新增
    addFamily(){
      this.accountResumeData.families.push(Object.assign({}, this.familieJson))
    },
    // 家庭成员-删除
    delFamilyMembersFunc(idx){
      this.$confirm('确定要删除该家庭成员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.accountResumeData.families = this.accountResumeData.families.filter((item, index) => index !== idx);
      });
    },
    // 学习经历-双击编辑
    handleLearingRowDblClick(row){
      console.log(row,'学习')
      this.$set(row, "isEditing", true);
      row.dateRange = [row.beginDate,row.endDate]
    },
    // 学习经历-结束编辑，保存数据
    saveLearningEdit(row, field, idx) {
      let { educations } = this.accountResumeData
      if (idx > -1) {
        if (field === 'dateRange') {
          this.$set(educations[idx], 'beginDate', row.dateRange[0])
          this.$set(educations[idx], 'endDate', row.dateRange[1])
        } else {
          this.$set(educations[idx], field, row[field]);
        }
      }
      row.isEditing = false; // 退出编辑模式
    },
    // 学习经历-新增
    addEducation(){
      this.accountResumeData.educations.push(Object.assign({}, this.educationJson))
    },
    // 学习经历-删除
    delEducationFunc(idx){
      this.$confirm('确定要删除该学习经历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 使用索引删除指定项
        this.accountResumeData.educations = this.accountResumeData.educations.filter((item, index) => index !== idx);
      });
    },
    // 工作经历-双击编辑工作经历
    handleWorkRowDblClick(row){
      this.$set(row, "isEditing", true);
      row.dateRange = [row.beginDate,row.endDate]
    },
    
    // 工作经历-结束编辑，保存数据
    saveWorkEdit(row, field, idx) {
      let { works } = this.accountResumeData
      if (idx > -1) {
        if (field === 'dateRange') {
          this.$set(works[idx], 'beginDate', row.dateRange[0])
          this.$set(works[idx], 'endDate', row.dateRange[1])
        } else {
          this.$set(works[idx], field, row[field]);
        }
      }
      row.isEditing = false; // 退出编辑模式
    },
    // 工作经历--新增
    addWork(){
      this.accountResumeData.works.push(Object.assign({}, this.workJson))
    },
    // 工作经历-删除索引为idx的项
    delWorkFunc(idx){
      this.$confirm('确定要删除该工作经历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 使用索引删除指定项
        this.accountResumeData.works = this.accountResumeData.works.filter((item, index) => index !== idx);
      });      
    },
    checkCard(cardType, cardNumber) {
      let str4 = cardNumber.slice(0, 4);
      if (cardType === "10") {
        if (str4 != "8100" && str4 != "8200") {
          return ERR.IE1024;
        }
      }
      if (cardType === "11") {
        if (str4 != "8300") {
          return ERR.IE1025;
        }
      }
      if (
        cardType === "1" ||
        cardType === "7" ||
        cardType === "10" ||
        cardType === "11"
      ) {
        const res = ValidateUtility.card(cardNumber); // ValidateUtility.card中已验证-证件号中的字母必须为大写
        if (!res.istrue) {
          return ERR.IE1004;
        }
        const reg =
          /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
        switch (cardNumber.length) {
          case 18:
            if (reg.test(cardNumber)) {
              const S =
                (parseInt(cardNumber[0]) + parseInt(cardNumber[10])) * 7 +
                (parseInt(cardNumber[1]) + parseInt(cardNumber[11])) * 9 +
                (parseInt(cardNumber[2]) + parseInt(cardNumber[12])) * 10 +
                (parseInt(cardNumber[3]) + parseInt(cardNumber[13])) * 5 +
                (parseInt(cardNumber[4]) + parseInt(cardNumber[14])) * 8 +
                (parseInt(cardNumber[5]) + parseInt(cardNumber[15])) * 4 +
                (parseInt(cardNumber[6]) + parseInt(cardNumber[16])) * 2 +
                parseInt(cardNumber[7]) * 1 +
                parseInt(cardNumber[8]) * 6 +
                parseInt(cardNumber[9]) * 3;
              const Y = S % 11;
              let M = "F";
              const JYM = "10X98765432";
              M = JYM.substr(Y, 1);
              if (M !== cardNumber[17].toUpperCase()) {
                return ERR.IE1020;
              }
            }
        }
      }
      if (cardType === "8") {
        if (!/^[A-Z]/.test(cardNumber.substr(0, 1))) {
          return ERR.IE1017; // IE1017: '出生证的证件号首字母必须为大写',
        }
      }
      /**
       * 证件类型为护照，则：护照号码位数不能低于3个字符。护照号码中如包含字母，则字母应为大写
       */
      if (cardType === "2") {
        const reg_passport = /^([A-Z]|[0-9]){3,25}$/; // 护照
        if (cardNumber.length < 3) {
          return ERR.IE1019; // IE1019: '证件类型为护照，护照号码位数不能低于3个字符',
        }
        if (!reg_passport.test(cardNumber)) {
          return ERR.IE1020; // IE1020: '请您输入有效的证件号码'
        }
      }
      /**
       * 证件类型为台湾居民来往大陆通行证，则：台湾居民来往大陆通行证的号码位数不少于8个字符。
       * 如有字母应大写
       */
      if (cardType === "6") {
        if (cardNumber.length < 8) {
          return ERR.IE1020;
        }
        const reg_passport = /^([A-Z]|[0-9]){8,}$/;
        if (!reg_passport.test(cardNumber)) {
          return ERR.IE1020;
        }
      }
      /**
       * 证件类型为港澳居民往来内地通行证，则: 港澳居民往来内地通行证号码组成规则：通行证证件号码共9位,首位只能为H或M
       */
      if (cardType === "5") {
        if (
          cardNumber.length !== 9 ||
          (cardNumber[0] !== "H" && cardNumber[0] !== "M")
        ) {
          return ERR.IE1020;
        } else {
          const reg = /^[0-9]*$/g;
          if (!reg.test(cardNumber.substring(1))) {
            return ERR.IE1020;
          }
        }
      }
      /**
       * 若证件类型为军官证、士兵证，则：
          a)军官证、士兵证号码位数，不能为9位以下或18位以上，号码信息必须包含汉字。包含汉字9<=N<=18,且一个汉字占一位。
          b)军官证只能录入：汉字+数字
      */
      if (cardType === "3" || cardType === "4") {
        if (cardNumber.length < 9 || cardNumber.length > 18) {
          return ERR.IE1020;
        } else {
          const rega = /[\u4E00-\u9FA5]/g;
          if (!rega.test(cardNumber)) {
            return ERR.IE1020;
          }
        }
      }
      /** 证件类型非身份证、非户口本的证件类型、非港澳居民居住证、台湾居民居住证，不允许证件号码仍为15位或18位，不应符合身份证号相关的校验规则 */
      if (
        !(
          cardType === "1" ||
          cardType === "7" ||
          cardType === "10" ||
          cardType === "11"
        )
      ) {
        if (cardNumber.length == 15 || cardNumber.length == 18) {
          return ERR.IE1026;
        }
      }
    }
    // // 工作经历-编辑
    // editWorkRow(row) {
    //   this.$set(row, "isEditing", true);
    //   this.$set(row, "oldData",{ ...row });
    //   row.dateRange = [row.beginDate, row.endDate]
    // },
    // // 保存行
    // saveWorkRow(row) {
    //   row.isEditing = false;
    //   row.oldData = {}; // 清空备份
    // },
    // cancelWorkEdit(row) {
    //   Object.assign(row, row.oldData); // 还原数据
    //   row.isEditing = false;
    //   row.oldData = {};
    // },
  }
}


// WEBPACK FOOTER //
// ./src/pages/recruit/officeSaff/js/base.js